export interface User{
    id : string;
    username? : string | null;
    email? : string | null;
    password : string | null;
    customerId : string | null;

}
export interface AdminUser{
   username : string
}

export interface LoginRequest{
    username:string;
    password:string;
}

export function CreateLoginRequest() : LoginRequest {
    return {
        username : '',
        password : '',
    };
}